export default __webpack_public_path__ + "static/media/2650ddd03b369639381ecc100baaf930.png";